import React, { useEffect } from 'react';
import { Card, Form, Input, Switch, Button, message, Space } from 'antd';
import { SettingOutlined, SaveOutlined, SyncOutlined } from '@ant-design/icons';
import { useSystemStore } from '../store';

const System: React.FC = () => {
  const { settings, updateSettings, fetchSettings } = useSystemStore();
  const [form] = Form.useForm();

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  useEffect(() => {
    if (settings) {
      form.setFieldsValue(settings);
    }
  }, [settings, form]);

  const onFinish = async (values: any) => {
    try {
      await updateSettings(values);
      message.success('系统设置保存成功');
    } catch (error) {
      console.error('保存失败:', error);
      message.error('保存失败，请重试');
    }
  };

  const onReset = () => {
    form.resetFields();
    if (settings) {
      form.setFieldsValue(settings);
    }
  };

  return (
    <div style={{ padding: '0 24px 24px' }}>
      <Card
        title={
          <Space>
            <SettingOutlined />
            <span>系统设置</span>
          </Space>
        }
        bordered={false}
        style={{ borderRadius: 8 }}
      >
        <Form
          form={form}
          name="system_settings"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="🌐 站点名称"
            name="siteName"
            rules={[{ required: true, message: '请输入站点名称!' }]}
          >
            <Input placeholder="例如：FunHua Admin" />
          </Form.Item>

          <Form.Item
            label="📝 站点描述"
            name="siteDescription"
            rules={[{ required: true, message: '请输入站点描述!' }]}
          >
            <Input.TextArea
              rows={3}
              placeholder="简要描述站点的功能和用途"
              showCount
              maxLength={200}
            />
          </Form.Item>

          <Form.Item
            label="✅ 允许注册"
            name="enableRegistration"
            valuePropName="checked"
            tooltip="开启后允许新用户注册"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            label="📧 邮箱验证"
            name="enableEmailVerification"
            valuePropName="checked"
            tooltip="开启后用户注册需要验证邮箱"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            label="🔧 维护模式"
            name="maintenanceMode"
            valuePropName="checked"
            tooltip="开启后系统将进入维护状态，普通用户无法访问"
          >
            <Switch />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
            <Space size="large">
              <Button
                type="primary"
                htmlType="submit"
                icon={<SaveOutlined />}
                size="large"
              >
                保存设置
              </Button>
              <Button
                htmlType="button"
                onClick={onReset}
                icon={<SyncOutlined />}
              >
                重置
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default System;
